<template>
  <div class="order-list">
    <h3>任务订单管理</h3>
    <el-form :inline="true" ref="formTask" class="demo-form-inline" size="mini">
      <el-form-item label="甲方昵称">
        <el-input
          v-model="filter.nickNameA"
          placeholder="请输入甲方昵称"
          size="small"
        ></el-input>
      </el-form-item>
      <el-form-item label="甲方手机">
        <el-input
          v-model="filter.phoneNumberA"
          placeholder="请输入甲方手机"
          size="small"
        ></el-input>
      </el-form-item>
      <el-form-item label="乙方昵称">
        <el-input
          v-model="filter.nickNameB"
          placeholder="请输入乙方昵称"
          size="small"
        ></el-input>
      </el-form-item>
      <el-form-item label="乙方手机">
        <el-input
          v-model="filter.phoneNumberB"
          placeholder="请输入乙方手机"
          size="small"
        ></el-input>
      </el-form-item>
      <el-form-item label="订单编号">
        <el-input
          v-model="filter.taskOrderId"
          placeholder="请输入订单编号"
          size="small"
        ></el-input>
      </el-form-item>
      <el-form-item label="母编号">
        <el-input
          v-model="filter.mainTaskOrderId"
          placeholder="请输入母编号"
          size="small"
        ></el-input>
      </el-form-item>

      <el-form-item label="订单类型">
        <el-select v-model="filter.masterFlag">
          <el-option
            :label="k"
            :value="v"
            v-for="(k, v) in statusTask"
            :key="v"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button-group>
          <el-button type="primary" @click="fetch(1)" size="mini"
            >查询</el-button
          >
        </el-button-group>
      </el-form-item>
      <el-form-item>
        <el-button-group>
          <el-button type="primary" @click="resetQuery()" size="mini"
            >重置</el-button
          >
        </el-button-group>
      </el-form-item>
    </el-form>
    <el-table :data="list" size="mini" v-loading="loading">
      <el-table-column prop="taskOrderId" label="订单编号" width="200px" />

      <el-table-column prop="mainTaskOrderId" label="母编号" width="200px" />

      <el-table-column prop="title" width="260px" label="任务标题" />
      <el-table-column prop="nickNameA" label="甲方昵称" width="200px" />
      <el-table-column prop="phoneNumberA" label="甲方手机" width="120px" />
      <el-table-column prop="nickNameB" label="乙方昵称" width="200px" />
      <el-table-column prop="phoneNumberB" width="120px" label="乙方手机" />
      <el-table-column prop="price" label="单价" />
      <el-table-column prop="fee" width="140px" label="手续费" />
      <el-table-column width="120px" prop="amount" label="接单金额" />
      <el-table-column prop="masterFlag" label="订单类型">
        <template slot-scope="scope">
          {{ scope.row.masterFlag === 0 ? "甲方" : "乙方" }}
        </template>
      </el-table-column>
      <el-table-column prop="status" width="140px" label="任务状态">
        <template slot-scope="scope">
          {{
            scope.row.status == 1
              ? "任务中"
              : scope.row.status === 2
              ? "待结算"
              : scope.row.status === 3
              ? "已完成"
              : scope.row.status === 4
              ? "已取消"
              : scope.row.status === 5
              ? "任务成果已验收"
              : ""
          }}
        </template>
      </el-table-column>

      <el-table-column prop="createTime" width="180px" label="发布时间" />
      <el-table-column label="操作" fixed="right" width="100px">
        <template slot-scope="scope">
          <el-button-group size="mini">
            <el-button size="mini" type="primary" @click="goDetail(scope.row)"
              >查看订单</el-button
            >
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
    <br />
    <div style="float: right">
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="(i) => (pageNum = i)"
        :page-size="limit"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import request from "../request";
import qs from "qs";
import map from "../../datamap";
import moment from "moment";
import api from "../api";

const { taskInfo, taskOrder, per, order, user } = api;

export default {
  name: "user-list",
  data() {
    return {
      loading: true,
      list: [],
      total: 0,
      limit: 20,
      pageNum: 1,
      total: 0,
      filter: {
        taskInfoId: null,
        title: null,
        nickNameA: null,
        phoneNumberA: null,
        nickNameB: null,
        phoneNumberB: null,
        mainTaskOrderId: null,
        masterFlag: null,
        status: null,
        releaseCreateTimeStr: null,
        releaseCreateTimeStr: null,
      },
      valueTime: [],

      statusTask: {
        0: "甲方",
        1: "乙方",
      },
      pushDialogShow: false,
      pushUserId: "",
      pushData: {
        taskInfoId: "",
        userIds: [],
      },
      pushIng: false,
      dialogPayChannel: false,
      curOrder: null,
    };
  },
  components: {},
  computed: {
    nickUserName() {
      return location.search;
    },
    payChannel() {
      return map.payChannel;
    },
  },
  watch: {
    pageNum() {
      this.fetch();
    },
  },
  methods: {
    async fetch(num) {
      if (num == 1) {
        this.pageNum = 1;
      }
      let pageNum = this.pageNum;
      let limit = this.limit;
      this.loading = true;
      let {
        taskOrderId,
        title,
        nickNameA,
        phoneNumberA,
        nickNameB,
        phoneNumberB,
        mainTaskOrderId,
        masterFlag,
        status,
      } = this.filter;

      let obj = {
        pageNum: pageNum,
        limit: limit,
        taskOrderId,
        title,
        nickNameA,
        phoneNumberA,
        nickNameB,
        phoneNumberB,
        mainTaskOrderId,
        masterFlag,
        status,
      };
      if (this.valueTime) {
        obj.releaseCreateTimeStr = this.valueTime[0] || null;
        obj.releaseEndTimeStr = this.valueTime[1] || null;
      }

      if (
        this.filter.taskOrderId ||
        this.filter.nickNameA ||
        this.filter.phoneNumberA ||
        this.filter.nickNameB ||
        this.filter.phoneNumberB ||
        this.filter.mainTaskOrderId ||
        this.filter.masterFlag
      ) {
        this.$set(obj, "paramsFlag", 1);
      } else {
        this.$set(obj, "paramsFlag", 0);
      }

      let res = await taskOrder.list(obj);

      this.list = res.data.data;
      this.loading = false;
      this.total = res.data.pageinfo.totalCount;
    },

    resetQuery() {
      this.valueTime = [];
      this.filter = {};
      this.fetch();
      // this.$refs["formTask"].resetFields();
    },
    goDetail(row) {
      let isManger = true;
      let iframeUrl = `${this.frontUrl}/taskHostingPage/taskOrderDetail?isMangOrderId=${row.taskOrderId}`;
      // let iframeUrl = `http://localhost:8086/taskHostingPage/taskOrderDetail?isMangOrderId=${row.taskOrderId}`;
      window.location.href = iframeUrl;
    },
  },
  mounted() {
    this.fetch();
  },
};
</script>
<style>
.fon-tex-coll {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>


// WEBPACK FOOTER //
// src/views/taskManage/taskOrder.vue